import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@/core/localization';
import { forwardRef } from 'react';
import { MenuItemStyled } from './NotSelectedMenuItem.styled';
/**
 * `Select` works only with a `MenuItem` as its direct child, not with a component that renders one: it reads `value`
 * and `children` off the child element itself, then clones it to inject its own click handler and ref. So a wrapper
 * like this one has to take `value` from the caller and pass on everything it receives, otherwise the item is rendered
 * but stays dead to clicks.
 */
const NotSelectedMenuItem = forwardRef(({ value, ...props }, ref) => (_jsx(MenuItemStyled, { ...props, ref: ref, children: _jsx("em", { children: t('not.selected.label') }) })));
export { NotSelectedMenuItem };
